export const search_icon = (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7.9125 14.075C11.454 14.075 14.325 11.204 14.325 7.6625C14.325 4.12097 11.454 1.25 7.9125 1.25C4.37097 1.25 1.5 4.12097 1.5 7.6625C1.5 11.204 4.37097 14.075 7.9125 14.075Z" stroke="#613917" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M15 14.7499L13.65 13.3999" stroke="#613917" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
    </svg>

)